<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="contact__background module__background"
            v-if="[1, 2, 3, 4].includes(module.layout.type)"
        >
        </app-modulebackground>
        <div
            class="contact__container module__container"
            v-bind:class="{ container__fluid: [1, 2, 3, 4, 5, 6].includes(module.layout.type) }"
        >
            <div class="contact__inner module__inner">
                <div
                    class="contact__inner-main module__inner--main"
                    v-bind:class="{
                        'bg-color': [1, 2].includes(module.layout.type),
                        'calc-padding--left': [5].includes(module.layout.type),
                        'calc-padding--right': [6].includes(module.layout.type)
                    }"
                >
                    <div
                        class="contact__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="contact__inner-col module__inner-col">
                            <div
                                class="contact__header module__header"
                                v-bind:class="{
                                    container__boxed: [3, 4].includes(module.layout.type)
                                }"
                            >
                                <h2
                                    class="contact__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="contact__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <!--
                    <div
                        class="contact__inner-row module__inner-row"
                        v-if="[4].includes(module.layout.type)"
                    >
                        <div class="contact__inner-col module__inner-col">
                            <div class="contact__map module__map">
                                <app-map v-if="[4].includes(module.layout.type)"> </app-map>
                            </div>
                        </div>
                    </div>
                    -->
                    <div class="contact__inner-row module__inner-row" v-if="module.data.text">
                        <div class="contact__inner-col module__inner-col">
                            <div
                                class="contact__text module__text font-p color-p module__cms"
                                v-bind:class="{
                                    container__boxed: [3, 4].includes(module.layout.type)
                                }"
                                v-if="module.data.text"
                                v-html="module.data.text"
                            ></div>
                        </div>
                    </div>
                    <div class="contact__inner-row module__inner-row">
                        <div class="contact__inner-col module__inner-col">
                            <div
                                class="contact__details"
                                v-bind:class="{
                                    'flex--wrap': [3].includes(module.layout.type),
                                    'container__boxed flex--wrap': [3, 4].includes(
                                        module.layout.type
                                    )
                                }"
                            >
                                <ul class="contact__details-list">
                                    <li
                                        class="contact__details-list-item font-bold"
                                        v-if="data('firma1')"
                                    >
                                        {{ data('firma1') }}
                                    </li>
                                    <li
                                        class="contact__details-list-item font-bold"
                                        v-if="misc('firmierung')"
                                    >
                                        {{ misc('firmierung') }}
                                    </li>
                                    <li
                                        class="contact__details-list-item font-bold"
                                        v-if="data('strasse')"
                                    >
                                        {{ data('strasse') }}
                                    </li>
                                    <li
                                        class="contact__details-list-item font-bold"
                                        v-if="data('plz') && data('ort')"
                                    >
                                        {{ data('plz') }} {{ data('ort') }}
                                    </li>
                                    <li
                                        class="contact__details-list-item font-bold"
                                        v-if="data('land')"
                                    >
                                        {{ data('land') }}
                                    </li>
                                </ul>
                                <ul class="contact__details-list">
                                    <li
                                        class="contact__details-list-item font-bold"
                                        v-if="data('telefon')"
                                    >
                                        Telefon:
                                        <a
                                            :href="'tel:' + data('telefon')"
                                            class="font-bold module__link--underlined"
                                            >{{ data('telefon') }}</a
                                        >
                                    </li>
                                    <li
                                        class="contact__details-list-item font-bold"
                                        v-if="data('fax')"
                                    >
                                        Fax: {{ data('fax') }}
                                    </li>
                                    <li
                                        class="contact__details-list-item font-bold"
                                        v-if="data('email')"
                                    >
                                        E-Mail:
                                        <a
                                            :href="'mailto:' + data('email')"
                                            class="font-bold module__link--underlined"
                                            >{{ data('email') }}</a
                                        >
                                    </li>

                                    <app-emergencyphone
                                        custom-tag="li"
                                        custom-class="contact__details-list-item font-bold border-color"
                                    ></app-emergencyphone>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div
                        class="contact__inner-row module__inner-row"
                        v-if="
                            (module.data.link && module.data.link.active) ||
                                (module.data.link2 && module.data.link2.active) ||
                                (module.data.link3 && module.data.link3.active)
                        "
                    >
                        <div class="contact__inner-col module__inner-col">
                            <div
                                class=" contact__cta module__cta"
                                v-bind:class="{
                                    container__boxed: [3, 4].includes(module.layout.type)
                                }"
                            >
                                <app-modulebutton
                                    :data="module.data.link"
                                    :custom-class="
                                        'contact__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                >
                                </app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link2"
                                    :custom-class="
                                        'contact__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                >
                                </app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link3"
                                    :custom-class="
                                        'contact__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                >
                                </app-modulebutton>
                            </div>
                        </div>
                    </div>
                    <div class="contact__inner-row module__inner-row">
                        <div class="contact__inner-col module__inner-col">
                            <div
                                class="contact__text module__text font-p font-small color-p module__cms"
                                v-bind:class="{
                                    container__boxed: [3, 4].includes(module.layout.type)
                                }"
                            >
                              Ihre personenbezogenen Daten verarbeiten wir gemäß Art. 6 Abs. 1 S. 1 lit. b DSGVO zur Bearbeitung Ihrer Anfrage. Weitere Informationen zu unserem Umgang mit personenbezogenen Daten, insbesondere zu Ihren Rechten als betroffene Person, finden Sie in unseren
                                <router-link
                                    v-bind:to="getPrivacyLink"
                                    :target="getPrivacyTarget"
                                    :class="'font-bold module__link--underlined'"
                                    >Datenschutzinformationen</router-link
                                >.
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="contact__inner-map module__inner--map"
                    v-bind:class="{
                        container__fluid: [3].includes(module.layout.type)
                    }"
                >
                    <div class="contact__map module__map">
                        <div
                            v-if="
                                [1, 2, 3, 5, 6].includes(module.layout.type) && !hasModuleBackground
                            "
                            v-bind:style="
                                'background-image: url(\'' +
                                    generateMediaUrl({
                                        path: 'media/images/contact/map.jpg'
                                    }) +
                                    '\')'
                            "
                            class="contact__map-optin-bg"
                        ></div>
                        <div
                            v-if="[5, 6].includes(module.layout.type) && hasModuleBackground"
                        >
                            <app-modulebackground
                                :module-id="module.id"
                                custom-class="contact__background module__background"
                            >
                            </app-modulebackground>
                        </div>
                        <!--
                        <app-map v-if="[1, 2, 3, 5, 6].includes(module.layout.type)"> </app-map>
                        -->
                    </div>
                </div>
            </div>
        </div>

        <div class="contact__map-optout border-color-highlighted" v-if="!this.editorMode">
            <span class="contact__map-optout-toggler-wrap">
                <input
                    type="checkbox"
                    id="contact__map-optout-toggler"
                    class="contact__map-optout-toggler"
                    name="contact__map-optout-toggler"
                />
                <label
                    class="contact__map-optout-toggler-label font-small"
                    for="contact__map-optout-toggler"
                    v-html="$helpers.uiText('F001')"
                ></label>
            </span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import EmergencyPhone from '@/components/assorted/EmergencyPhone';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import Map from '@/components/assorted/Map';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-map': Map,
        'app-emergencyphone': EmergencyPhone,
        'app-modulebackground': ModuleBackground
    },
    methods: {
        data(prop) {
            return this.getProp('deha.user.' + prop);
        },
        misc(prop) {
            return this.getProp('deha.user.misc.' + prop);
        }
    },
    computed: {
        ...mapGetters([
            'getProp',
            'editorMode',
            'getPageUrlFromSlug',
            'generateMediaUrl',
            'getModuleBackground'
        ]),
        getPrivacyLink() {
            return this.getPageUrlFromSlug('/datenschutz') || '';
        },
        getPrivacyTarget() {
            return this.editorMode ? '_self' : '_blank';
        },
        hasModuleBackground() {
            return this.getModuleBackground(this.module.id);
        }
    },
    mounted() {},
    updated() {},
    props: {
        module: Object
    }
};
</script>
